// extracted by mini-css-extract-plugin
export default {"events":"createevents_events__o55qQ","text":"createevents_text__iyVFH","typo":"createevents_typo__sW6u5"};